import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { RSCBase } from 'src/app/controllers/base/RSCBase';
import { IAPIEndpoint } from '../endpoints/endpoints';
import { AuthService, initialized } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  _beforeRequests: any = {};

  constructor(
    //public system: SystemAPIService,
    //public user: UserAPIService,
    //public admin: AdminAPIService,
    //public client: ClientAPIService,
    public __auth: AuthService,
    private alertController: AlertController,
    private translate: TranslateService,
    private platform: Platform,
  ) {
    RSCBase.setApireference(this);
  }

  get initialized() {
    return initialized;
  }

  get Http() {
    return this.__auth?.http?.Http;
  }

  addBeforeRequest(key: string, callback: any) {
    this._beforeRequests[key] = callback;
  }

  removeBeforeRequest(key: string) {
    delete this._beforeRequests[key];
  }

  request(endpoint: IAPIEndpoint, params?: any): Observable<any> {
    if (endpoint._before) {
      ({ params } = endpoint._before(params));
    }
    for (let _before in this._beforeRequests) {
      ({ params } = this._beforeRequests[_before](endpoint, params));
    }
    if (
      params?.query &&
      endpoint.options.headers['Content-Type'] != 'application/json'
    ) {
      params.query = JSON.stringify(params.query) as any;
    }
    return (this.__auth as any)['_' + endpoint.method](
      endpoint.url,
      params,
      endpoint.options,
      endpoint.version,
    );
  }

  public async _newVersionAlert(versionCode: string, downloadUrl: any) {
    downloadUrl = this.platform.is('ios')
      ? downloadUrl.ios
      : downloadUrl.android;
    const alert = await this.alertController.create({
      header: this.translate.instant('[AQUI] system.update.new_version.header'),
      subHeader: this.translate.instant(
        '[AQUI] system.update.new_version.sub_header',
      ),
      message: this.translate.instant(
        '[AQUI] system.update.new_version.header',
        { version: versionCode },
      ),
      buttons: [
        {
          text: this.translate.instant(
            '[AQUI] system.update.new_version.cancel_btn',
          ),
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {},
        },
        {
          text: this.translate.instant(
            '[AQUI] system.update.new_version.update_btn',
          ),
          handler: () => {
            window.open(downloadUrl, '_blank');
          },
        },
      ],
    });

    await alert.present();
  }

  public async _updateRequiredAlert(versionCode: string, downloadUrl: any) {
    downloadUrl = this.platform.is('ios')
      ? downloadUrl.ios
      : downloadUrl.android;
    const alert = await this.alertController.create({
      header: this.translate.instant('[AQUI] system.update.required.header'),
      subHeader: this.translate.instant(
        '[AQUI] system.update.required.sub_header',
      ),
      message: this.translate.instant('[AQUI] system.update.required.message', {
        version: versionCode,
      }),
      backdropDismiss: false,
      keyboardClose: false,

      buttons: [
        {
          text: this.translate.instant(
            '[AQUI] system.update.required.update_btn',
          ),
          handler: () => {
            window.open(downloadUrl, '_blank');
            return false;
          },
        },
      ],
    });

    await alert.present();
  }
}
